import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=3e9dc51d&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e9dc51d')) {
      api.createRecord('3e9dc51d', component.options)
    } else {
      api.reload('3e9dc51d', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=3e9dc51d&", function () {
      api.rerender('3e9dc51d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Company/Register/Company.vue"
export default component.exports